import { useLanguage } from "../../../../contexts/LanguageContext"

/**
 * Main step-by-step bubble component.
 * Renders the core bubble content with title, description, and step counter.
 * @param {Object} props
 * @param {Object} props.parameters - Configuration parameters
 * @returns {JSX.Element}
 */
export default function StepBubble({ parameters }) {
  const { t } = useLanguage()

  return (
    <>
      <span id="stepIconFile" data-testid="stepIconFile" className="hopscotch-bubble-sbs"></span>
      <div className="hopscotch-bubble-content">
        <h3 className="hopscotch-title hopscotch-Valign">{t("Sbs.sbsBubbleTitle")}</h3>
        <div className="hopscotch-content">
          {t("Sbs.sbsBubbleContent")}
          <div></div>
        </div>
      </div>
      <div className="hopscotch-bubble-number">
        <span>2/5</span>
      </div>
    </>
  )
}
